var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 20V18.2222C4 17.2792 4.3746 16.3749 5.0414 15.7081C5.70819 15.0413 6.61256 14.6667 7.55556 14.6667H11.1111C12.0541 14.6667 12.9585 15.0413 13.6253 15.7081C14.2921 16.3749 14.6667 17.2792 14.6667 18.2222V20M15.5556 4.11545C16.3204 4.31127 16.9983 4.75607 17.4823 5.37973C17.9664 6.00338 18.2292 6.77041 18.2292 7.5599C18.2292 8.34938 17.9664 9.11641 17.4823 9.74006C16.9983 10.3637 16.3204 10.8085 15.5556 11.0043M20 19.9999V18.2221C19.9955 17.4374 19.7315 16.6762 19.2491 16.0572C18.7668 15.4381 18.0932 14.9961 17.3333 14.7999M5.77778 7.55556C5.77778 8.49855 6.15238 9.40292 6.81918 10.0697C7.48597 10.7365 8.39034 11.1111 9.33333 11.1111C10.2763 11.1111 11.1807 10.7365 11.8475 10.0697C12.5143 9.40292 12.8889 8.49855 12.8889 7.55556C12.8889 6.61256 12.5143 5.70819 11.8475 5.0414C11.1807 4.3746 10.2763 4 9.33333 4C8.39034 4 7.48597 4.3746 6.81918 5.0414C6.15238 5.70819 5.77778 6.61256 5.77778 7.55556Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.72b292921254b3e02e9e6c1f6cfdaa55.svg";
export { ForwardRef as ReactComponent };